import React, { useContext } from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import lendsqr from "../../img/lendsqr.png";
import Bankist from "../../img/bankist.png";
import Forkify from "../../img/forkify.png";
import Mapty from "../../img/mapty.png";
import Dashboard from "../../img/React Dashboard.png";
import MiniBankist from "../../img/miniBankist.png";
import PigGame from "../../img/pigGame.png";
import Devxp from "../../img/devxp2.png";
import { themeContext } from "../../Context";
import { Link } from "react-router-dom";

const Testimonials = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const clients = [
    {
      img: Forkify,
      link: "https://forkify2023.netlify.app",
    },

    {
      img: Bankist,
      link: "https://bankist2022.netlify.app",
    },
    {
      img: Dashboard,
      link: "https://adminpanel-max.netlify.app/",
    },
    {
      img: Mapty,
      link: "https://mapty2022.netlify.app",
    },
    {
      img: PigGame,
      link: "https://piggame100.netlify.app",
    },
    {
      img: MiniBankist,
      link: "https://github.com/NwekeMaxwell/mini-bankist",
    },
    {
      img: lendsqr,
      link: "https://nweke-maxwell-lendsqr-fe-test.netlify.app",
    },
    {
      img: Devxp,
      link: "https://devxp-react-projects.vercel.app/",
    },
  ];
  return (
    <div className="t-wrapper" id="Testimonials">
      <div className="t-heading">
        <span style={{ color: darkMode ? "var(--tertiary-light)" : "" }}>
          Some Outstanding{" "}
        </span>
        <span>Projects</span>
        {/* <span>Employers & Clients always get</span>
        <span>Exceptional Work</span>
        <span>from me...</span> */}
        <div className="blur t-blur-1"></div>
        <div className="blur t-blur-2"></div>
      </div>
      {/* slider */}
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        loop={true}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <a href={client.link} className="testimonials">
                <img src={client.img} alt="" onClick={() => {}} />
              </a>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="viewAllBtn">
        <Link to="/projects">View All Projects &rarr;</Link>
      </div>
    </div>
  );
};

export default Testimonials;
